<!--

 -->

<template>
  <login-layout>
    <div class="login">
      <oxd-text class="gsl-hrm-login-title" tag="h5">
        Login to your Account
      </oxd-text>
      <div class="gsl-hrm-login-form">
        <div class="gsl-hrm-login-error">
          <oxd-alert
            :show="error !== null"
            :message="error?.message || ''"
            type="error"
          ></oxd-alert>
          <oxd-sheet
            v-if="isDemoMode"
            type="gray-lighten-2"
            class="gsl-hrm-demo-credentials"
          >
            <oxd-text tag="p">Username : Admin</oxd-text>
            <oxd-text tag="p">Password : Test@er123</oxd-text>
          </oxd-sheet>
        </div>
        <oxd-form
          ref="loginForm"
          method="post"
          :action="submitUrl"
          @submit-valid="onSubmit"
        >
          <input name="_token" :value="token" type="hidden" />

          <oxd-form-row>
            <oxd-input-field
              v-model="username"
              name="username"
              :label="$t('general.username')"
              label-icon="person"
              :placeholder="$t('auth.username')"
              :rules="rules.username"
              autofocus
            />
          </oxd-form-row>

          <oxd-form-row>
            <oxd-input-field
              v-model="password"
              name="password"
              :label="$t('general.password')"
              label-icon="key"
              :placeholder="$t('auth.password')"
              type="password"
              :rules="rules.password"
            />
          </oxd-form-row>

          <oxd-form-actions class="gsl-hrm-login-action">
            <oxd-button
              class="gsl-hrm-login-button"
              display-type="main"
              :label="$t('auth.login')"
              type="submit"
            />
          </oxd-form-actions>
          <div class="gsl-hrm-login-forgot">
            <oxd-text class="gsl-hrm-login-forgot-header" @click="navigateUrl">
              {{ $t('auth.forgot_password') }}?
            </oxd-text>
          </div>
        </oxd-form>
        <template v-if="authenticators?.length > 0">
          <oxd-divider class="gsl-hrm-login-seperator"></oxd-divider>
          <social-media-auth
            :authenticators="authenticators"
          ></social-media-auth>
        </template>
        <br />
      </div>
      <div class="gsl-hrm-login-footer">
        <div v-if="showSocialMedia" class="gsl-hrm-login-footer-sm">
          <a
            v-if="showSocialUrls?.facebook"
            :href="showSocialUrls.facebook"
            target="_blank"
          >
            <oxd-icon type="svg" class="gsl-hrm-sm-icon" name="facebookFill" />
          </a>
          <a
            v-if="showSocialUrls?.linkedIn"
            :href="showSocialUrls.linkedIn"
            target="_blank"
          >
            <oxd-icon type="svg" class="gsl-hrm-sm-icon" name="linkedinFill" />
          </a>
        </div>
        <slot name="footer"></slot>
      </div>
    </div>
  </login-layout>
</template>

<script>
import {urlFor} from '@ohrm/core/util/helper/url';
import {required} from '@ohrm/core/util/validation/rules';
import {navigate, reloadPage} from '@ohrm/core/util/helper/navigation';
import LoginLayout from '../components/LoginLayout';
import {OxdAlert, OxdSheet, OxdIcon} from '@ohrm/oxd';
import SocialMediaAuth from '@/orangehrmAuthenticationPlugin/components/SocialMediaAuth.vue';

export default {
  components: {
    'oxd-alert': OxdAlert,
    'oxd-sheet': OxdSheet,
    'oxd-icon': OxdIcon,
    'login-layout': LoginLayout,
    'social-media-auth': SocialMediaAuth,
  },

  props: {
    error: {
      type: Object,
      default: () => null,
    },
    token: {
      type: String,
      required: true,
    },
    showSocialMedia: {
      type: Boolean,
      default: true,
    },
    showSocialUrls: {
      type: Object,
      default: () => ({}),
    },
    isDemoMode: {
      type: Boolean,
      default: false,
    },
    authenticators: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      username: '',
      password: '',
      rules: {
        username: [required],
        password: [required],
      },
      submitted: false,
    };
  },

  computed: {
    submitUrl() {
      return urlFor('/auth/validate');
    },
  },

  beforeMount() {
    setTimeout(() => {
      reloadPage();
    }, 1200000); // 20 * 60 * 1000 (20 minutes);
  },

  methods: {
    onSubmit() {
      if (!this.submitted) {
        this.submitted = true;
        this.$refs.loginForm.$el.submit();
      }
    },
    navigateUrl() {
      navigate('/auth/requestPasswordResetCode');
    },
  },
};
</script>

<style src="./login.scss" lang="scss" scoped></style>
